export type FilterTagProps = { text: string };

export function FilterTag({ text }: FilterTagProps) {
  return (
    <span className="rounded bg-gray-200 px-1.5 py-0.5 text-sm font-medium">
      {text}
    </span>
  );
}
